export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=7010ba02c528a42e16dbf830ccc3fae0427c627131&name=pushAdClickData!'